import { apiGetRequest, apiPostRequest } from "../utils/webrequests";
import { PartnerUser } from "../data/PartnerUserData";

/**
 * Fetch partner users details by PartnerID.
 * @param partnerId - The GUID of the partner organization.
 */
export async function getPartnerUsersByPartnerId(partnerId: string): Promise<PartnerUser[]> {
    try {
        console.log("Fetching Partner Users for:", partnerId);
        const response = await apiGetRequest(`partner-user/${partnerId}`, null);
        console.log(response);

        // Check if response has a success status and valid partnerUsers array
        if (!response || response.status !== 'success' || !Array.isArray(response.partnerUsers)) {
            throw new Error('Invalid response from API');
        }

        console.log("Partner Users Response:", response.partnerUsers);
        return response.partnerUsers;
    } catch (error: any) {
        throw new Error(`Failed to fetch partner users: ${error.message}`);
    }
}

/**
 * Add a new partner user.
 * @param partnerUser - The partner user object containing PartnerID, UserID, and SponsorAdmin.
 */
export async function addPartnerUser(partnerUser: { PartnerID: string; UserID: string; SponsorAdmin: boolean }): Promise<any> {
    try {
        const response = await apiPostRequest("AddPartnerUser", partnerUser);
        return response;
    } catch (error: any) {
        throw new Error(`Failed to add partner user: ${error.message}`);
    }
}

/**
 * Delete a partner user.
 * @param partnerId - The GUID of the partner.
 * @param partnerUserId - The GUID of the partner user to be deleted.
 */
export async function deletePartnerUser(partnerId: string, partnerUserId: string): Promise<any> {
    try {
        const response = await apiPostRequest("DeletePartnerUser", {
            partnerId: partnerId,   // Ensure the key matches backend expectation
            partnerUserId: partnerUserId // Corrected key name
        });
        return response;
    } catch (error: any) {
        throw new Error(`Failed to delete partner user: ${error.message}`);
    }
}
/*
 * Edit a partner user's SponsorAdmin status.
 * @param partnerUserId - The GUID of the partner user to edit.
 * @param updateData - The updated data for the partner user.
 */
export async function editPartnerUser(partnerUserId: string, updateData: Partial<PartnerUser>): Promise<PartnerUser> {
    try {
        console.log("Editing Partner User:", partnerUserId, "with data:", updateData);
        const response = await apiPostRequest(`partner-user/${partnerUserId}`, updateData);

        // Check if response has a success status and valid partnerUser object
        if (!response || response.status !== 'success' || !response.partnerUser) {
            throw new Error('Invalid response from API during edit operation');
        }

        console.log("Updated Partner User Response:", response.partnerUser);
        return response.partnerUser;
    } catch (error: any) {
        throw new Error(`Failed to edit partner user: ${error.message}`);
    }
}

/**
 * Fetch all partners from the GetPartners API.
 * @returns An array of all partners.
 */
export async function getAllPartners(): Promise<any[]> {
    try {
        console.log("Calling GetPartners API...");
        const response = await apiGetRequest("GetPartners", null);

        // Check if the response is valid JSON
        let data;
        try {
            data = typeof response === 'string' ? JSON.parse(response) : response;
        } catch (jsonError) {
            console.error("Failed to parse response as JSON:", jsonError);
            throw new Error('JSON Parse error: Invalid API response format');
        }

        if (!Array.isArray(data)) {
            console.error("API did not return an array of partners. Raw response:", data);
            throw new Error('Invalid response from API');
        }

        console.log("Fetched Partners:", data);
        return data;
    } catch (error: any) {
        console.error("Failed to fetch all partners:", error.message);
        throw new Error(`Failed to fetch partners: ${error.message}`);
    }
}